<template>
  <a-space class="taote-space">
    <a-popover v-if="params.value === 'taoteKeyword'"
      ref="taotePopover"
      trigger="click"
      title="支持输入关键字搜索淘特类目"
      :autoAdjustOverflow="false"
    >
      <template #content>
        <a-space>
          <a-input
            v-model:value="currentItem.catName"
            placeholder="输入关键词, 搜索淘特类目"
            style="width: 230px;"
            @keydown.enter="searchCategory"
          />
          <a-button
            type="primary" class="search-btn"
            @click="searchCategory"
            >搜索</a-button
          >
        </a-space>
      </template>
      <a-cascader
        popupClassName="taote-category-cascader-popup"
        ref="taoteCategoryCascader"
        style="width: 270px;"
        v-model:value="currentItem.params.catId"
        :options="currentItem.categoryList"
        expand-trigger="click"
        placeholder="请选择 1 个类目"
        :load-data="loadCategoryData"
        :changeOnSelect="true"
        @change="searchGoods"
      />
    </a-popover>
    <!-- <a-select v-else v-model:value="currentItem.params.catId" placeholder="请选择 1 个类目" 
      style="width: 190px" allowClear :filter-option="filterSelect" show-search  @change="searchGoods">
      <a-select-option v-for="item in currentItem.categoryList" :key="item.value" :value="item.value">
        {{ item.label }}
      </a-select-option>
    </a-select> -->
    <a-select
      v-model:value="currentItem.params.sort"
      placeholder="请选择排序"
      allowClear
      @change="searchGoods"
    >
      <a-select-option
        v-for="item in currentItem.sortOptions"
        :key="item.value" :value="item.value"
      >
        {{ item.label }}
      </a-select-option>
    </a-select>
    <a-input
        v-model:value="currentItem.params.keyword"
        placeholder="请输入关键字"
        allowClear
        @keydown.enter="searchGoods"
    />
    <a-button type="primary" class="search-btn" @click="searchGoods">
      <SearchOutlined />搜索
    </a-button>
    <template v-if="params.value === 'taoteKeyword'">
      <a-radio-group
        button-style="solid"
        v-model:value="currentItem.params.poolId"
        @change="searchGoods"
      >
        <a-radio-button
          v-for="item in currentItem.typeOptions"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </a-radio-button>
      </a-radio-group>
      <a-space style="font-size: 15px; white-space: nowrap; flex-wrap: wrap">
        <div>
          价格:
          <template v-for="(item, i) in priceList" :key="item.label">
            <a-input 
              v-model:value="currentItem.params[item.key]"
              :placeholder="item.label"
              style="width: 93px"
              allowClear
              @pressEnter="searchGoods"
            />
            <span v-show="!i"> ~ </span>
          </template>
        </div>
        <div v-for="item in list" :key="item.label">
        {{ item.label }}:
          <a-select
            v-model:value="currentItem.params[item.key]"
            :placeholder="'选择' + item.label"
            allowClear
            @change="searchGoods"
          >
            <a-select-option
              v-for="item in currentItem.lvOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </div>
        <a-button type="primary" danger @click="clearFilerOptions">
          清空筛选项
        </a-button>
      </a-space>
    </template>
  </a-space>
</template>
<script>
import { SearchOutlined } from "@ant-design/icons-vue"
import { LoadCategoryData, SearchTaoteCategory } from '../utils'
export default {
  components: { SearchOutlined },
  data() {
    return {
      currentItem: {
        params: {},
        lvOptions: [],
        sortOptions: []
      },
      list: [
        { label: '好评率', key: 'posReviewLv' }, { label: '退货率', key: 'refundLv' }
      ],
      priceList: [
        { label: '最小值', key: 'minPrice' }, { label: '最大值', key: 'maxPrice' }
      ]
    }
  },
  props: {
    params: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    searchGoods() {
      if (!this.currentItem.params?.catId?.length && this.currentItem.value === 'taoteKeyword') {
        this.currentItem.catName = ''
        this.searchCategory()
      }
      this.$emit('searchGoods')
    },
    clearFilerOptions() {
      this.currentItem.params.minPrice = this.currentItem.params.maxPrice = this.currentItem.params.refundLv = this.currentItem.params.posReviewLv = this.currentItem.params.cstLv = this.currentItem.params.shipLv = null
      this.searchGoods()
    },
    loadCategoryData(selectedOptions) {
      LoadCategoryData(this, selectedOptions)
    },
    // 搜索淘特的类目
    searchCategory() {
      SearchTaoteCategory(this)
    },
    // 搜索-下拉列表
    filterSelect(input, option) {
      return option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  },
  watch: {
    'params.value': {
      handler() {
        this.currentItem = this.params
      },
      immediate: true
    }
  }
}
</script>
<style scoped lang='less'>
  .taote-space {
    flex-wrap: wrap;
    .ant-select {
      width: 132px;
      font-size: 15px;
    }
  }
</style>